import { a as P, t as _ } from "./common-Cd7R8f1s.js";
import { n as f } from "./Logger-CmiOOsKC.js";
import { t as E } from "./tracebehavior-5_qSKjs6.js";
import { n as M } from "./bindingValues-BuN2Qy2j.js";
import { t as x } from "./imageanchordata-dKT5zAcc.js";
import { Quaternion as l, Vector3 as h } from "@babylonjs/core/Maths/math.vector.js";
import { Mesh as b } from "@babylonjs/core/Meshes/mesh.js";
import { MeshBuilder as I } from "@babylonjs/core/Meshes/meshBuilder.js";
import { StandardMaterial as A } from "@babylonjs/core/Materials/standardMaterial.js";
import "@babylonjs/core/Meshes/Builders/planeBuilder.js";
import { Texture as w } from "@babylonjs/core/Materials/Textures/texture.js";
function y(t) {
  if (t.length === 0) return !0;
  const r = t[0], e = r.transform.rotationQuaternion ?? l.FromEulerVector(r.transform.rotation), i = h.Up();
  return i.applyRotationQuaternionInPlace(e), Math.abs(i.y) >= 0.7;
}
function T(t, r) {
  return !(t === _.Vertical || t === _.Horizontal) && (r ?? 0) === 0;
}
function S(t, r, e) {
  return T(t, r) ? y(e) ? 0 : -Math.PI / 2 : P(t, r);
}
var v = x, R = 0.2, W = class extends E {
  static behaviorType = "ImageAnchor";
  static cmsManaged = !0;
  _preview = null;
  _material = null;
  _texture = null;
  _aspect = 1;
  _previewEnabled = !0;
  async applyCommit(t) {
    "src" in t && await this._loadTexture(), this._rebuildPreview(), ("orientation" in t || "pitchDegrees" in t) && this._applySceneRootRotation();
  }
  load() {
    return this._loadTexture();
  }
  onAttach(t) {
    this._rebuildPreview();
  }
  onDetach() {
    this._disposePreview(), this._texture?.dispose(), this._texture = null;
  }
  _applySceneRootRotation() {
    const t = this._resolved.orientation, r = this._resolved.pitchDegrees, e = this.sceneObject, i = e.transform.rotationQuaternion?.clone() ?? l.Identity(), n = e.transform.position.clone(), d = /* @__PURE__ */ new Map(), a = e.getChildren();
    for (const o of a) {
      o.transform.computeWorldMatrix(!0);
      const s = o.transform.rotationQuaternion?.clone() ?? l.FromEulerVector(o.transform.rotation);
      d.set(o, {
        worldRot: i.multiply(s),
        worldPos: o.transform.getAbsolutePosition().clone()
      });
    }
    const u = S(t, r, a), p = l.RotationYawPitchRoll(0, u, 0);
    e.transform.rotationQuaternion = p;
    const c = p.clone();
    c.invertInPlace();
    for (const o of a) {
      const s = d.get(o);
      if (!s) continue;
      o.transform.rotationQuaternion = c.multiply(s.worldRot);
      const g = s.worldPos.subtract(n), m = new h(0, 0, 0);
      g.rotateByQuaternionToRef(c, m), o.transform.position.copyFrom(m);
    }
    f.debug(`[ImageAnchor] Scene-root rotation applied for orientation=${t ?? "unset"} pitch=${(u * 180 / Math.PI).toFixed(2)}°, ${a.length} child world pose(s) preserved`);
  }
  _loadTexture() {
    this._texture?.dispose(), this._texture = null, this._aspect = 1;
    const t = this._resolved.src;
    return M(t) ? new Promise((r) => {
      const e = new w(t, this.scene, !1, !0, w.BILINEAR_SAMPLINGMODE, () => {
        const { width: i, height: n } = e.getSize();
        this._aspect = n > 0 ? i / n : 1, this._texture = e, r();
      }, (i) => {
        f.warn(`[ImageAnchor] Texture error for "${t}": ${i}`), e.dispose(), r();
      });
    }) : Promise.resolve();
  }
  _rebuildPreview() {
    if (this._disposePreview(), !this._texture) return;
    const t = I.CreatePlane(v, {
      size: 1,
      sideOrientation: b.BACKSIDE
    }, this.scene), r = this._resolved.widthMeters && this._resolved.widthMeters > 0 ? this._resolved.widthMeters : R;
    t.scaling = new h(this._aspect * r, r, 1);
    const e = new A(`${v}_mat`, this.scene);
    e.emissiveTexture = this._texture, e.disableLighting = !0, t.material = e, t.parent = this.sceneObject.transform, t.setEnabled(this._previewEnabled), this._preview = t, this._material = e;
  }
  _disposePreview() {
    this._preview?.dispose(), this._preview = null, this._material?.dispose(), this._material = null;
  }
  get orientation() {
    return this._resolved.orientation;
  }
  get pitchDegrees() {
    return this._resolved.pitchDegrees ?? 0;
  }
  setPreviewEnabled(t) {
    this._previewEnabled = t, this._preview?.setEnabled(t);
  }
  get previewEnabled() {
    return this._previewEnabled;
  }
  get widthMeters() {
    return this._resolved.widthMeters && this._resolved.widthMeters > 0 ? this._resolved.widthMeters : R;
  }
};
export {
  T as n,
  S as r,
  W as t
};

//# sourceMappingURL=imageanchor-DusNzbVp.js.map